import {charcoal} from '../sass/base/_exports.sass';

export const ReflectVerticalIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 25"
      style={style}
      fill="none"
    >
      <path
        d="M6.25 21.75H18.25L12.25 15.75L6.25 21.75ZM18.25 3.75H6.25L12.25 9.75L18.25 3.75ZM3.25 11.75H6.25V13.75H3.25V11.75ZM8.25 11.75H11.25V13.75H8.25V11.75ZM13.25 11.75H16.25V13.75H13.25V11.75ZM18.25 11.75H21.25V13.75H18.25V11.75Z"
        fill={color}
      />
    </svg>
  );
};
